import React from "react";
import ReactDOM from "react-dom";
import "bootstrap";
import App from "./App";
import "./styles/root.scss";
import { store } from "./app/store";
import { Provider } from "react-redux";
import "./utils/interceptors"; // Runs mid-flight logic on all API calls

import * as serviceWorker from "./serviceWorker";
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
